var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#174350",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 124 124",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.1,54.5H0v51.4c0,3.1,2.5,5.6,5.6,5.6h112c3.5,0,6.4-2.9,6.4-6.4V35.6c0-3.4-2.7-6.1-6.1-6.1H89.1 c-3,0-5.5-2.2-5.899-5.1l-1-6.6c-0.5-2.9-3-5.3-5.9-5.3H47.5c-3,0-5.5,2.3-5.9,5.3l-1,6.6c-0.4,2.9-3,5.1-5.9,5.1H6 c-3.3,0-6,2.7-6,6v5h18.1c3.8,0,6.9,3.1,6.9,6.9v0.1C25,51.4,21.9,54.5,18.1,54.5z M108,40.7c3.9,0,7,3.1,7,7c0,3.9-3.1,7-7,7 s-7-3.1-7-7C101,43.9,104.1,40.7,108,40.7z M62.3,43.2c16.601,0,30,13.4,30,30c0,16.6-13.399,30-30,30c-16.6,0-30-13.4-30-30 C32.3,56.6,45.8,43.2,62.3,43.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 73.2,
    r: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.08bb25f5cbc20448e7a0ab477cc910e0.svg";
export { ForwardRef as ReactComponent };